<app-page-header [header]="getPageHeader()" [showBackButton]="false" />
<app-user-search />
<p-confirmDialog key="userSavedMsg"/>